class HelperService {
  buildSearchQueryString(filters: any) {
    let query = "?"

    for (const key in filters) {
      if (filters[key] !== null && filters[key] !== undefined) {
        query += `${key}=${filters[key]}&`
      }
    }

    query = query.slice(0, -1)

    return query
  }

  showNotfyErr(notyf: any, error: any, customMessage?: string) {
    const msg = error?.response?.data?.error || null
    notyf.error(msg || customMessage || "Oops! Try again or shout for help.")
  }
}

export default new HelperService()
